/* RESPONSIBLE TEAM: team-ai-agent-2 */

import { GroupSummary, type GroupSummaryWireFormat } from './group-summary';
import {
  PlaygroundQuestionGeneration,
  type PlaygroundQuestionGenerationWireFormat,
} from './question-generation';

export type PlaygroundSummaryWireFormat = {
  group_summaries: GroupSummaryWireFormat[];
  question_generation_summary: PlaygroundQuestionGenerationWireFormat;
  max_question_limit: number;
};

export class PlaygroundSummary {
  groupSummaries: GroupSummary[];
  questionGenerationSummary: PlaygroundQuestionGeneration;
  questionLimit: number;

  constructor(
    groupSummaries: GroupSummary[],
    questionGenerationSummary: PlaygroundQuestionGeneration,
    questionLimit: number,
  ) {
    this.groupSummaries = groupSummaries;
    this.questionGenerationSummary = questionGenerationSummary;
    this.questionLimit = questionLimit;
  }

  static deserialize(data: PlaygroundSummaryWireFormat): PlaygroundSummary {
    return new PlaygroundSummary(
      data.group_summaries.map((summary) => GroupSummary.deserialize(summary)),
      PlaygroundQuestionGeneration.deserialize(data.question_generation_summary),
      data.max_question_limit,
    );
  }
}
